import React from 'react';
import { displayWindow } from './sportsTime';
import { guideWindowStart, GUIDE_WINDOW_MS } from './guideWindow';

export default function GuideWindowControls({ start, timeZone, onChange, live }) {
  const earliest = Date.now() - 13 * 86400000; const latest = Date.now() + 14 * 86400000;
  return <div className="lineup-epg__window" aria-label="Programme time window">
    <button type="button" disabled={start - GUIDE_WINDOW_MS < earliest} onClick={() => onChange(start - GUIDE_WINDOW_MS)}>Earlier programmes</button>
    <button type="button" aria-pressed={live} onClick={() => onChange(guideWindowStart(), true)}>Now</button>
    <button type="button" disabled={start + 2 * GUIDE_WINDOW_MS > latest} onClick={() => onChange(start + GUIDE_WINDOW_MS)}>Later programmes</button>
    <span>{displayWindow(new Date(start).toISOString(), new Date(start + GUIDE_WINDOW_MS).toISOString(), timeZone)} · {timeZone}</span>
  </div>;
}
